import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CaretLeft } from "@phosphor-icons/react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarItem,
} from "@hulahoop/ui";
import { ROUTES } from "@/app/routes";
import { SETTINGS_NAVIGATION, SETTINGS_NAVIGATION_GROUPS } from "./settingsNavigation";

export function SettingsSidebar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <Sidebar>
      <SidebarHeader className="gap-2 border-b-0 px-2 pb-0">
        <SidebarItem
          render={<Link to={ROUTES.DASHBOARD} />}
          icon={CaretLeft}
          className="text-sidebar-foreground-secondary"
        >
          {t("settings.back_to_app")}
        </SidebarItem>
        <h1 className="px-2 pt-1 text-lg font-semibold text-sidebar-foreground">
          {t("settings.title")}
        </h1>
      </SidebarHeader>

      <SidebarContent
        className="gap-2 pt-2"
        role="navigation"
        aria-label={t("settings.navigation")}
      >
        {SETTINGS_NAVIGATION_GROUPS.map((group) => (
          <SidebarGroup key={group}>
            <SidebarGroupLabel>{t(group)}</SidebarGroupLabel>
            {SETTINGS_NAVIGATION.filter((item) => item.group === group).map(
              ({ path, label, icon: Icon }) => (
                <SidebarItem
                  key={path}
                  render={<Link to={path} />}
                  icon={Icon}
                  active={pathname === path}
                >
                  {t(label)}
                </SidebarItem>
              ),
            )}
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
